import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=c41af14a&scoped=true&"
import script from "./Workbench.vue?vue&type=script&lang=js&"
export * from "./Workbench.vue?vue&type=script&lang=js&"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=c41af14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41af14a",
  null
  
)

export default component.exports